import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Llevaba 2 años pensando que mi hijo era difícil. En 3 días de aplicar el método CVR entendí que era yo quien necesitaba el sistema.',
    name: 'María G.',
    location: 'Mamá de Sebastián (5 años) · Texas',
    image: 'https://cdn.magicpatterns.com/uploads/m5Z5Jr9f7VsoWeauacF8Gb/Maria_G._comp.png'
  }, {
    quote: 'Por $7 pensé que iba a ser otro PDF genérico. Me equivoqué. El checklist SOS Rabietas lo tengo pegado en el refrigerador.',
    name: 'Carmen R.',
    location: 'Mamá de 3 niños · California',
    image: 'https://cdn.magicpatterns.com/uploads/wjqnXtuuXr8AJhyHrrq4kc/CARMEN_R..png'
  }, {
    quote: 'La primera noche que usé el paso VINCULAR antes de pedir que se cepillara los dientes... no hubo pelea. Lloré de alivio.',
    name: 'Daniela M.',
    location: 'Florida',
    image: 'https://cdn.magicpatterns.com/uploads/3XJRZDk8Re8sdnTT8Ao4wV/DANIELA_M..png'
  }];
  return <section className="py-10 md:py-20 px-5 bg-white" data-id="element-171">
      <div className="max-w-3xl mx-auto" data-id="element-172">
        <FadeIn data-id="element-173">
          <h2 className="font-serif text-3xl md:text-4xl text-brand-navy text-center mb-12" data-id="element-174">
            Lo que dicen las mamás que ya lo están aplicando:
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-175">
          {testimonials.map((test, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-176">
              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-slate-100" data-id="element-177">
                <div className="flex gap-1 mb-4 text-yellow-400" data-id="element-178">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-179" />)}
                </div>
                <p className="font-sans text-lg text-slate-700 italic mb-6 leading-relaxed" data-id="element-180">
                  "{test.quote}"
                </p>
                <div className="flex items-center gap-4" data-id="element-181">
                  <img src={test.image} alt={test.name} className="w-12 h-12 rounded-full object-cover border-2 border-brand-orange/20 shrink-0" data-id="element-182" />
                  <div data-id="element-183">
                    <span className="font-bold text-brand-navy block" data-id="element-184">
                      — {test.name}
                    </span>
                    <span className="text-slate-500 text-sm" data-id="element-185">
                      {test.location}
                    </span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}